export interface InternetInterface {
  name: string;
  description: string;
  status: 'on' | 'off';
  default: 'true' | 'false';
  addresses: string[];
  gateways: string[];
}

// This is what we get from the config call.
export interface ElevenAgentData {
  // The agent ships agentId with a capital D. It'd be nice to homoginize on a convention. So Id is left as an option.
  agentId?: string;
  agentID?: string;
  fqdn: string;
  host: string;
  interfaces: Record<string, InternetInterface>;
  publicIp: string;
  version: string;
  user?: string;
}

export enum ElevenDataRequestState {
  NOTCALLED = 'not called',
  FAILED = 'failed',
  WAITING = 'waiting',
  SUCCESS = 'success'
}

export interface ElevenDataContainerNotSuccess {
  state:
    | ElevenDataRequestState.NOTCALLED
    | ElevenDataRequestState.WAITING
    | ElevenDataRequestState.FAILED;
  playGuid: string;
  ts: number;
}
export interface ElevenDataContainerSuccess {
  state: ElevenDataRequestState.SUCCESS;
  data: ElevenAgentData;
  playGuid: string;
  ts: number;
}

export type ElevenDataContainer =
  | ElevenDataContainerNotSuccess
  | ElevenDataContainerSuccess;
